import { render, staticRenderFns } from "./assembly.vue?vue&type=template&id=064446b6&scoped=true&"
import script from "./assembly.vue?vue&type=script&lang=js&"
export * from "./assembly.vue?vue&type=script&lang=js&"
import style0 from "./assembly.vue?vue&type=style&index=0&id=064446b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064446b6",
  null
  
)

export default component.exports